import React, { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import Sidebar from "../Sidebar";
import { Toaster } from "../ui/Toaster";
import ScopeSearch from "./ScopeSearch";
import FocusView from "./FocusView";
import { SCOPE_TYPES } from "./api";

const CustomDictionary = ({ setAuth, setUserOrg }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const scopeType = String(searchParams.get("type") || "").toUpperCase();
    const scopeId = searchParams.get("id");
    const org = searchParams.get("org") || undefined;
    const specialty = searchParams.get("specialty") || undefined;
    const focus =
        SCOPE_TYPES[scopeType] && scopeId
            ? { scopeType, scopeId, org, specialty }
            : null;

    const setFocus = useCallback(
        (target) => {
            if (!target) {
                setSearchParams({});
                return;
            }
            const next = { type: target.scopeType, id: target.scopeId };
            if (target.org) next.org = target.org;
            if (target.specialty) next.specialty = target.specialty;
            setSearchParams(next);
        },
        [setSearchParams],
    );

    return (
        <div className="flex">
            <div className="h-[100dvh]">
                <div className="fixed top-0 flex h-[100%]">
                    <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
                </div>
            </div>
            <div
                className="overflow-x-hidden"
                style={{
                    marginLeft: "var(--sidebar-width, 250px)",
                    width: "calc(100% - var(--sidebar-width, 250px))",
                }}
            >
                <div className="mx-auto max-w-5xl px-6 py-8">
                    <header className="mb-6">
                        <h1 className="text-[28px] font-bold text-ktx-purple">
                            Custom Dictionary
                        </h1>
                    </header>

                    {focus ? (
                        <FocusView
                            key={`${focus.scopeType}:${focus.scopeId}:${focus.org || ""}:${focus.specialty || ""}`}
                            focus={focus}
                            onFocusChange={setFocus}
                            onBackToSearch={() => setFocus(null)}
                        />
                    ) : (
                        <ScopeSearch onSelect={setFocus} />
                    )}
                </div>
                <Toaster />
            </div>
        </div>
    );
};

export default CustomDictionary;
